/* src/app/features/solicitacao-arquivos/pesquisa/solicitacao-arquivos.pesquisa.scss */
/*# sourceMappingURL=solicitacao-arquivos.pesquisa.css.map */
